<template>
  <Select v-model="value"
          :data-title="$t('message.monitoring.message.types')"
          :data-menu-heading="$t('message.monitoring.message.types')"
          data-menu-width="350px"
          :data-button-gradient="true"
          :data-items="options"
          @input="setOperationsFilter"
          @search="searchIds($event)" />
</template>

<script>
    import Select from '@components/Select'

    export default {
        components: {
          Select
        },

        data() {
            return {
              initalOptions: [
                {
                  label: this.$t('message.monitoring.message.estabNoActiveCampaign'),
                  id: 'LOCAL_WITHOUT_CAMPAIGN'
                },
                {
                  label: this.$t('message.monitoring.message.advertiserNoActiveCampaign'),
                  id: 'ADVERTISER_WITHOUT_CAMPAIGN'
                },
                {
                  label: this.$t('message.monitoring.message.noAccesses'),
                  id: 'LOCAL_WITHOUT_ACCESS'
                }
              ],
              options: [],
              value: []
            }
        },

        methods: {
          setOperationsFilter(val) {
            this.$store.commit('SYSTEMWARNING_SET_FILTER', {key: 'type', value: val})
          },
          searchIds(search) {
            this.options = search ? this.initalOptions.filter((option) => {
              return option.label.includes(search);
            }) : this.initalOptions;
          },
        },

        async mounted() {
          this.options = [...this.initalOptions];
        },
    }
</script>

<style scoped>
</style>
